import type { GetServerSideProps, NextPage } from 'next/types';
import SponsoredPage from 'pages/Sponsored/SponsoredPage';
import type { HeaderNav } from 'interfaces/navigation/Header';
import getFooter from 'api/Footer/getFooter';
import type { Article } from 'interfaces/content/articles/Articles';
import sponsoredArticle from 'lib/mockData/Sponsored/sponsored-data';
import { setMockPianoConfig } from 'services/Piano';
import setSponsoredHeadData from 'components/Head/setSponsoredHeadData';
import setSponsoredPageAdConfig from 'services/Ad/config/setSponsoredPageAdConfig';
import { setarcSpanPageConfig } from 'services/ArcSpan';
import getMenu from 'api/Header/getMenu';
import { safe, safeAsync } from 'utils/errorHandlingUtils';
import fallbackData from 'lib/fallbackData/commonData';

interface SponsoredProps {
  article: Article;
}

const SponsoredNextPage: NextPage<SponsoredProps> = ({ article }: SponsoredProps) => (
  <SponsoredPage article={article} />
);

export default SponsoredNextPage;

export const getServerSideProps: GetServerSideProps = async (context) => {
  const url = `https://${context.req.headers.host}${context.resolvedUrl}`;

  let sponsoredHeadData;
  try {
    sponsoredHeadData = await setSponsoredHeadData(url);
  } catch (_error) {
    return {
      notFound: true,
    };
  }

  const menu: HeaderNav = await safeAsync(
    () => getMenu('LEFT_MENU_COM', 'RIGHT_MENU_COM', 'TOPIC_NAVIGATION_COM', 'own', null),
    fallbackData.headerNav,
  );
  const footer = await safeAsync(() => getFooter(), fallbackData.footer);

  const sponsoredPageData = { ...sponsoredArticle, title: sponsoredHeadData.title };
  const arcSpanPageConfig = safe(() => setarcSpanPageConfig(sponsoredPageData), fallbackData.arcSpanPageConfig);
  const pageAdConfig = safe(() => setSponsoredPageAdConfig(), fallbackData.pageAdConfig);

  return {
    props: {
      arcSpanPageConfig,
      article: sponsoredArticle,
      footer,
      headData: sponsoredHeadData,
      headerNav: menu,
      pageAdConfig,
      pianoPageConfig: setMockPianoConfig(),
    },
  };
};
